export const initValueEditOrViewClient = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    document: "",
    cep: "",
    city: "",
    uf: "",
    address: "",
    district: "",
    number: "",
    complement: ""
}